import * as React from 'react'
import { ComplianceStore } from '../ComplianceStore'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { Alberta } from './Alberta'
import { BritishColumbia } from './BritishColumbia'
import { Saskatchewan } from './Saskatchewan'
import { Nunavut } from './Nunavut'
import { NWTerritories } from './NWTerritories'
import { Ontario } from './Ontario'
import { ComplianceInfo } from '../ComplianceInfo'
import { Manitoba } from './Manitoba'
import { ComplianceTimeFrame } from '@getgreenline/compliance/build/models/BaseComplianceModels'
import { dayjs } from '../../../../../utilities/dayjs'
import { NewBrunswick } from './NewBrunswick'

export interface IProps {
  currentCompanyStore: CurrentCompanyStore
  complianceStore: ComplianceStore
}

export const ProvinceComplianceReport: React.FunctionComponent<IProps> = ({
  currentCompanyStore,
  complianceStore,
}: IProps) => {
  const province = currentCompanyStore.company!.province
  switch (province) {
    case 'AB':
      return <Alberta currentCompanyStore={currentCompanyStore} complianceStore={complianceStore} />
    case 'SK':
      return (
        <Saskatchewan currentCompanyStore={currentCompanyStore} complianceStore={complianceStore} />
      )
    case 'BC':
      return (
        <BritishColumbia
          currentCompanyStore={currentCompanyStore}
          complianceStore={complianceStore}
        />
      )
    case 'ON':
      return <Ontario currentCompanyStore={currentCompanyStore} complianceStore={complianceStore} />
    case 'MB':
      return (
        <Manitoba currentCompanyStore={currentCompanyStore} complianceStore={complianceStore} />
      )
    case 'NU':
      return <Nunavut currentCompanyStore={currentCompanyStore} complianceStore={complianceStore} />
    case 'NT':
      return (
        <NWTerritories
          currentCompanyStore={currentCompanyStore}
          complianceStore={complianceStore}
        />
      )
    case 'NB':
      return (
        <NewBrunswick currentCompanyStore={currentCompanyStore} complianceStore={complianceStore} />
      )
    default:
      return <div className='text-muted'>{province} has not released compliance reports.</div>
  }
}

export const GenerateComplianceReport: React.FunctionComponent<IProps> = ({
  currentCompanyStore,
  complianceStore,
}: IProps) => {
  const month = dayjs()
    .month(complianceStore.month - 1)
    .format('MMMM')
  const lastMonthOfQuarter = dayjs(month, 'MMMM').add(2, 'M').format('MMMM')

  return (
    <div>
      <div className='row'>
        <div className='col-md-6'>
          <h5>Download report</h5>
          <div className='text-muted'>
            Month of{' '}
            <u>
              {month}{' '}
              {complianceStore.timeFrame === ComplianceTimeFrame.QUARTERLY && (
                <>
                  {' - '}
                  {lastMonthOfQuarter}{' '}
                </>
              )}
              {complianceStore.year}
            </u>{' '}
            for <u>{complianceStore.locationIds.length} locations.</u>
          </div>
          <br />
          <ProvinceComplianceReport
            currentCompanyStore={currentCompanyStore}
            complianceStore={complianceStore}
          />
        </div>
        <div className='col-md-6'>
          <ComplianceInfo />
        </div>
      </div>
    </div>
  )
}
